export { default } from './SelectMenuWithFreeText';


// WEBPACK FOOTER //
// ./src/components/shared/SelectMenuWithFreeText/index.ts